import { gql, useLazyQuery } from '@apollo/client'

export interface ClearDecisionPageCacheVariables {
  dealId: number
}

export interface ClearDecisionPageCacheResponse {
  clearDecisionPageCache: {
    didError: boolean
    errorMessage: string
    message: string
    clearedKeys: string[]
  }
}

export const CLEAR_DECISION_PAGE_CACHE = gql`
  query ClearDecisionPageCache($dealId: Int!) {
    clearDecisionPageCache(dealId: $dealId) {
      didError
      errorMessage
      message
      clearedKeys
    }
  }
`

export const useClearDecisionPageCache = () => {
  const [clearCache, { data, loading, error }] = useLazyQuery<
    ClearDecisionPageCacheResponse,
    ClearDecisionPageCacheVariables
  >(CLEAR_DECISION_PAGE_CACHE, {
    fetchPolicy: 'network-only',
  })

  return {
    clearCache,
    data: data?.clearDecisionPageCache,
    loading,
    error,
  }
}
